/* global AFRAME */

AFRAME.registerComponent('stop-video', {
  schema: {
    on: {type: 'string'},
    target: {type: 'selector'},
    index: {type: 'number'}
  },

  init: function () {
    var data = this.data;
    var el = this.el;
    var self = this;

    el.addEventListener(data.on, () => {
      var videos = document.getElementsByTagName('video');

      for(var i = 0; i < videos.length; i++) {
        var video = videos[i];
        if (!video.paused && !video.ispaused) {
          video.pause();
          video.isplaying = false;
          video.ispaused = true;
        }
      }

      // Resets the material to black instead of frame of last-played video
      data.target.setAttribute('src', '#black');
    });
  }
});




// WEBPACK FOOTER //
// ./js/components/stop-video.js